import { ServiceMaker } from ".";

 export const getSingleImageUrl = (data:any) =>
  ServiceMaker("verification/upload/singleImage", "POST", data);

  export const verifyRequestImages = (data:any) =>
  ServiceMaker("verification/verifyImages", "POST", data);

  export const uploadRejectedImages = (data:any) =>
  ServiceMaker("booking/Requests/uploadRemainingImage", "POST", data);